import {
  ApprovalRule,
  RequestorRule,
  ResourceRule,
  RoutingRule,
} from "@p0security/shared/types/workflow/types";
import { nonNullable } from "@p0security/shared/util/nonNullable";
import { Table } from "antd";
import stringify from "json-stable-stringify";
import { useCallback } from "react";

import { NamePreview } from "../components/previews/NamePreview";
import { RequestorPreview } from "../components/previews/RequestorPreview";
import { ResourcePreview } from "../components/previews/ResourcePreview";
import { ApprovalSummary } from "./common";

type Props = {
  jsonRules: RoutingRule[];
};

const SimpleTableView: React.FC<Props> = ({ jsonRules }) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name: string | undefined) => <NamePreview name={name} />,
    },
    {
      title: "Resource",
      dataIndex: "resource",
      key: "resource",
      render: (resource: ResourceRule) => (
        <ResourcePreview resource={resource} />
      ),
    },
    {
      title: "Identity",
      dataIndex: "requestor",
      key: "requestor",
      render: (preview: RequestorRule) => (
        <RequestorPreview requestor={preview} />
      ),
    },
    {
      title: "Access",
      dataIndex: "approval",
      key: "approvalCombined",
      render: (approvals: ApprovalRule[]) => (
        <ApprovalSummary record={approvals} />
      ),
    },
  ];

  const stringifyRecord = useCallback(
    (record: RoutingRule) => nonNullable(stringify(record)),
    []
  );

  return (
    <Table
      bordered
      columns={columns}
      dataSource={jsonRules}
      rowKey={stringifyRecord}
      pagination={false}
    />
  );
};

export default SimpleTableView;
